{
  "version": 1,
  "asset_id": "141b96e0-b189-4eb6-a0bc-7d2ee30b4122",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/141b96e0-b189-4eb6-a0bc-7d2ee30b4122/beverly-hills-shingle-roof-underlayment-1280w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/141b96e0-b189-4eb6-a0bc-7d2ee30b4122/beverly-hills-shingle-roof-underlayment-1280w.avif",
  "original_filename": "beverly-hills-shingle-roof-underlayment-1280w.avif",
  "size": 110485,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:51Z"
}
